export var camelToSnake = function (str) {
    return str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1_').toLowerCase();
};
//# sourceMappingURL=index.js.map